import axios from 'axios';
import { fetchData } from './utils';
import { getUserId } from '../utils/auth';

const baseUrl = process.env.REACT_APP_BASE_URL;


  export const fetchConsultationAppointments = async(userId, access_token) => {
    try{
      const response = await fetchData(`user_product_appointments/filter/user_id/`,
              { user_id: userId, schema: "public" },
              access_token
            );
            return response;
          }catch(error){
            return null
          }
  }

  export const scheduleAppointment = async (appointmentId, userId, scheduledAt, productName, access_token) => {
    try {
       const updatedEntry = {
            id: appointmentId,
            user_id: userId,
            updated_by: userId,
            scheduled_at: scheduledAt,
            status: "Scheduled",
            updated_at: scheduledAt,
            product_name: productName
          }

      const response = await axios.put(
`${baseUrl}/user_product_appointments/filter/?id=${appointmentId}`,
        updatedEntry,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error scheduling appointment:", error);
      throw error;
    }
  };
